module.exports = __webpack_public_path__ + "static/media/leaveUp.e109703b.svg";